<template>
  <div>
    <CCard v-if="isSupportSummary" id="ga-track-Summary">
      <CCardBody>
        <div class="DivInline">
          <div class="title" style="margin-bottom: 0">
            地點潛力與初步建議
            <button class="pull-right toggle-button" @click="toggleSummary">
              <svg
                :class="{ 'rotate-180': isExpanded }"
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                />
              </svg>
            </button>
          </div>
        </div>
        <div style="font-size: 12px; margin-bottom: 5px; color: darkgray">
          此建議是由AI產生，可能會發生錯誤。請查核重要資訊。
        </div>
        <div v-if="isExpanded" class="c_markdown-body">
          <div :class="{ 'blur-style': lockedReport }">
            <div id="aicontent" v-html="renderMarkdown"></div>
          </div>
          <div v-if="isLoading">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" height="20" width="20" fill="#000">
              <rect x="0" y="13" width="4" height="5">
                <animate
                  attributeName="height"
                  attributeType="XML"
                  values="5;21;5"
                  begin="0s"
                  dur="0.6s"
                  repeatCount="indefinite"
                ></animate>
                <animate
                  attributeName="y"
                  attributeType="XML"
                  values="13; 5; 13"
                  begin="0s"
                  dur="0.6s"
                  repeatCount="indefinite"
                ></animate>
              </rect>
              <rect x="10" y="13" width="4" height="5">
                <animate
                  attributeName="height"
                  attributeType="XML"
                  values="5;21;5"
                  begin="0.15s"
                  dur="0.6s"
                  repeatCount="indefinite"
                ></animate>
                <animate
                  attributeName="y"
                  attributeType="XML"
                  values="13; 5; 13"
                  begin="0.15s"
                  dur="0.6s"
                  repeatCount="indefinite"
                ></animate>
              </rect>
              <rect x="20" y="13" width="4" height="5">
                <animate
                  attributeName="height"
                  attributeType="XML"
                  values="5;21;5"
                  begin="0.3s"
                  dur="0.6s"
                  repeatCount="indefinite"
                ></animate>
                <animate
                  attributeName="y"
                  attributeType="XML"
                  values="13; 5; 13"
                  begin="0.3s"
                  dur="0.6s"
                  repeatCount="indefinite"
                ></animate>
              </rect>
            </svg>
            正在處理 AI 分析...
          </div>
          <div v-if="error" class="text-danger">{{ error }}</div>
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>

<style scoped>
.DivInline {
  display: flex;
  justify-content: space-between; /* 使用 space-between 將內容推到兩端 */
  align-items: center;
  margin-bottom: 1rem;
}

.title {
  font-size: 1.25rem;
  font-weight: bold;
  margin-right: auto; /* 將標題的右邊距設為 auto，使其占据剩餘空間 */
}

.toggle-button {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.5rem;
  border: none;
  background-color: transparent;
  cursor: pointer;
  font-size: 0.875rem;
  color: #6c757d;
}

.toggle-button:hover {
  color: #3498db;
}

.toggle-button svg {
  width: 24px;
  height: 24px;
  margin-left: 0.25rem;
  transition: transform 0.3s ease;
}

.rotate-180 {
  transform: rotate(180deg);
}

.fade-in-text {
  animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
</style>

<script>
import axios from "axios";
import appSettings from "../util/settings";
import store from "../util/store";
import { mapState } from "vuex";
import { marked } from "marked";
export default {
  name: "reportsummarysection",
  components: {},
  data() {
    return {
      isSupportSummary: undefined,
      resportSummary: "",
      /* prompt:"",*/
      reportId: undefined,
      isExpanded: true,
      isLoading: false,
      error: "",
    };
  },
  computed: {
    ...mapState({
      lockedReport: (state) => state.lockedReport,
    }),
    renderMarkdown() {
      return marked(this.resportSummary);
    },
  },
  methods: {
    setData(id, islockReport, supportflag, resultSummaryObj) {
      this.reportId = id;
      if (supportflag === undefined) {
        this.isSupportSummary = false;
      } else {
        this.isSupportSummary = supportflag;

        // 如果 this.isSupportSummary 為 true 且 resultSummaryObj 為 null，呼叫 genReportSummary
        if (
          this.isSupportSummary &&
          (resultSummaryObj == null ||
            typeof resultSummaryObj === "undefined" ||
            Object.keys(resultSummaryObj).length === 0)
        ) {
          if (islockReport) {
            let sampleSummaryObj = {
              summary:
                "中正區適合開設平均客單價小於150元的早餐店，但需精準定位。\n\n**優勢：**推薦指數高，外送需求強勁，工作人口眾多，具備交通便利性及生活機能，學生族群有一定數量。\n\n**劣勢：**店租高，居住人口少，年長者比例高，便利商店消費力偏低，餐飲業競爭激烈，早餐店數量不多，可能表示市場已趨飽和或存在其他挑戰。\n\n**適合店家類型：**\n1.  **快速、平價、具特色早餐店：** 針對上班族，提供快速外帶、價格實惠的早餐，例如飯糰、三明治、特色麵包等。\n2.  **文青風格早餐店：** 吸引學生族群，提供平價、美味、具設計感的早餐，並提供舒適的用餐環境。\n\n**不適合類型：**高價位、精緻早午餐。\n\n**目標客群：**\n*   **上班族：** 快速、方便、價格實惠。\n*   **學生：** 平價、美味、具特色。\n\n**行銷方式：**\n*   **社群媒體：** Instagram、Facebook，分享美食照片、優惠活動，與粉絲互動。\n*   **外送平台：** 積極參與外送平台活動，提高曝光率。\n*   **團購優惠：** 與公司行號合作，提供團購優惠。\n\n**開店型態：**\n*   **外帶店：** 以外帶為主，減少店面空間，降低租金成本。\n*   **複合式經營：** 結合咖啡、輕食，增加營收來源。\n\n**競爭者狀況：**\n*   **連鎖早餐店：** JSP 呷尚宝、麥味登，需與之做出差異化。\n*   **便利商店：** 提供早餐組合，價格具競爭力。\n*   **其他餐飲店：** 小吃店、咖啡館等，提供早餐選項。\n\n**商品與價格：**\n*   **主打商品：** 飯糰、三明治、特色麵包、飲品。\n*   **價格帶：** 30-80元。\n*   **促銷方式：** 早餐套餐、集點活動、滿額折扣。\n*   **季節性商品：** 夏季推出清爽飲品、冬季推出暖心粥品。\n\n**是否選擇展店：**\n綜合考量，中正區具備一定潛力，但競爭激烈，需精準定位、做出差異化，並控制成本。若能找到合適地點、打造獨特品牌形象，仍有機會成功。\n\n祝展店順利！\n",
            };
            this.setReportSummary(sampleSummaryObj);
          } else {
            this.generateReportSummary();
          }
        }
        // 如果 this.isSupportSummary 為 true 且 resultSummaryObj 不為 null，設定 setReportSummary
        else if (this.isSupportSummary && resultSummaryObj !== null) {
          this.setReportSummary(resultSummaryObj);
        }
      }
    },
    generateReportSummary() {
      this.isLoading = true;
      this.error = "";

      axios
        .post(appSettings.GenerateReportAnalysisSummary, {
          userToken: store.state.token,
          id: this.reportId,
        })
        .then((response) => {
          this.taskId = response.data.taskId;
          localStorage.setItem("aiTaskId", this.taskId);

          if (response.data.status === "completed") {
            this.setReportSummary(JSON.parse(response.data.result));
            this.isLoading = false;
            localStorage.removeItem("aiTaskId");
          } else {
            setTimeout(() => this.pollTaskStatus(), 7000);
          }
        })
        .catch((error) => {
          this.error = "伺服器忙碌，請稍後再試";
          this.isLoading = false;
          //console.error(error);
        });
    },
    pollTaskStatus() {
      axios
        .post(appSettings.CheckReportAnalysisSummaryTaskStatus, {
          userToken: store.state.token,
          id: this.reportId,
        })
        .then((response) => {
          if (response.data.status === "completed") {
            this.setReportSummary(JSON.parse(response.data.result));
            this.isLoading = false;
            localStorage.removeItem("aiTaskId");
          } else if (response.data.status === "failed") {
            this.error = "伺服器忙碌，請稍後再試";
            //this.error = data.error;
            this.isLoading = false;
            localStorage.removeItem("aiTaskId");
          } else {
            this.pollTaskStatus();
          }
        })
        .catch((error) => {
          this.error = "伺服器忙碌，請稍後再試";
          this.isLoading = false;
          //console.error(error);
        });
    },
    setReportSummary(data) {
      //console.log(data)
      if (data) {
        let summary = data.summary;
        //summary = summary.replace(/\n\n/g, '<br>');
        //summary = summary.replace(/\n/g, '<br>');
        //summary = summary.replace(/\t/g, '');
        //summary = summary.replace(/\*\*(.*?)\*\*/g, '<strong>$1:</strong>');

        this.resportSummary = summary;
        //this.prompt = data.prompt;
      }
    },
    toggleSummary() {
      this.isExpanded = !this.isExpanded;
    },
  },
};
</script>
